let uniqId = 0;

export default () => uniqId += 1;
